const LOGOUT_REQUEST = 'load-logout-request'
const LOGOUT_SUCCESS = 'load-logout-success'

const logout = (state = {}, action = {}) => {
  switch (action.type) {
    case LOGOUT_REQUEST:
    case LOGOUT_SUCCESS:
      state = {}
      break
  }
  return state
}

export default logout
